import { useEffect, useState, useCallback } from 'react';
import api from '../services/api';

// How many things agents are waiting on people for, how many runs today, and how often people accept proposals.
// Polled once a minute and refreshed on demand (window event 'agents:changed'). A tenant without agents gets null.
export default function useAgentSummary({ pollMs = 60000 } = {}) {
  const [summary, setSummary] = useState(null);
  const load = useCallback(async () => {
    try {
      const res = await api.get('/agents/summary');
      setSummary(res.data?.data || null);
    } catch {
      setSummary(null);
    }
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, pollMs);
    window.addEventListener('agents:changed', load);
    return () => { clearInterval(t); window.removeEventListener('agents:changed', load); };
  }, [load, pollMs]);
  return { summary, reload: load };
}
